import classNames from "classnames";
import { Field, Form, withFormik } from "formik";
import Button from "pages/_components/Button";
import Container from "pages/_components/Container";
import TextField from "pages/_components/fields/TextField";
import Head from "pages/_components/Head";
import Hint from "pages/_components/hints/Hint";
import I18n from "pages/_components/I18n";
import Image from "pages/_components/Image";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import Productselector from "pages/forms/_components/_fields/Productselector";
import { arrayOf, bool, func, shape, string } from "prop-types";
import React, { Component } from "react";
import Col from "react-bootstrap/lib/Col";
import Row from "react-bootstrap/lib/Row";
import { connect } from "react-redux";
import { goBack, push } from "react-router-redux";
import { actions as accountsActions, selectors as accountsSelectors } from "reducers/accounts";
import { actions, selectors } from "reducers/checks";
import { selectors as sessionSelectors } from "reducers/session";
import { compose } from "redux";
import { maskedAccountNumber } from "util/accounts";
import { echeqShape } from "util/checks";
import { restoreEcheqTodoActionsIfNeeded } from "util/echeqTodoActionsSession";
import * as i18n from "util/i18n";
import {
    applyEmbeddedV3ShellLayoutState,
    clearEmbeddedV3ShellLayoutState,
    isUxDashboardImprovementsEnabled,
} from "util/v3ShellLayoutSync";
import Yup from "yup";
import { currencyMap } from "../../../../constants";

const FORM_ID = "echeqs";
class NegotiateEcheq extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        echeqAction: shape({
            action: string.isRequired,
            echeqList: arrayOf(echeqShape),
            specialAttribute: string.isRequired,
            confirmGoBackPath: string,
        }).isRequired,
        isDesktop: bool.isRequired,
        accounts: arrayOf(
            shape({
                idProduct: string.isRequired,
            }),
        ).isRequired,
        loggedUser: shape({}).isRequired,
        location: shape({}).isRequired,
        history: shape({
            location: shape({
                pathname: string,
            }),
        }).isRequired,
        embeddedInV3Shell: bool,
    };

    static defaultProps = {
        embeddedInV3Shell: false,
    };

    state = {
        showHintInfoMb: false,
    };

    componentDidMount() {
        const { dispatch, loggedUser, accounts = [], echeqAction } = this.props;
        if (!restoreEcheqTodoActionsIfNeeded(dispatch, echeqAction, actions)) {
            dispatch(push("/echeqs"));
            return;
        }
        if (accounts.length === 0) {
            dispatch(accountsActions.listAccounts(loggedUser.userId));
        }
        this.applyV3ShellLayout();
    }

    componentDidUpdate(prevProps) {
        const { embeddedInV3Shell, isDesktop, echeqAction } = this.props;
        if (
            prevProps.embeddedInV3Shell !== embeddedInV3Shell ||
            prevProps.isDesktop !== isDesktop ||
            prevProps.echeqAction !== echeqAction
        ) {
            this.applyV3ShellLayout();
        }
    }

    componentWillUnmount() {
        const { dispatch, embeddedInV3Shell, history } = this.props;
        if (embeddedInV3Shell) {
            clearEmbeddedV3ShellLayoutState(dispatch, { nextPathname: history?.location?.pathname || "" });
        }
    }

    getShellHeaderTitle = () => {
        const { echeqAction } = this.props;
        const titleKey = echeqAction.echeqList?.length > 1 ? "echeqs.negotiate.title.multi" : "echeqs.negotiate.title";
        return i18n.get(titleKey);
    };

    applyV3ShellLayout = () => {
        const { embeddedInV3Shell, isDesktop, dispatch, echeqAction } = this.props;
        applyEmbeddedV3ShellLayoutState(dispatch, {
            embeddedInV3Shell,
            isDesktop,
            scopes: ["echeqs"],
            headerTitle: this.getShellHeaderTitle(),
            goBackPath: echeqAction.confirmGoBackPath || "/echeqs",
            rightContentMobile: !isDesktop ? this.rightContentMobile() : undefined,
        });
    };

    handleBack = () => {
        const { dispatch, embeddedInV3Shell, echeqAction } = this.props;
        if (embeddedInV3Shell) {
            dispatch(push(echeqAction.confirmGoBackPath || "/echeqs"));
        } else {
            dispatch(goBack());
        }
    };

    rightContentMobile = () => {
        const { showHintInfoMb } = this.state;
        return (
            <button
                type="button"
                className="btn btn-hint"
                onClick={() => this.setState((prev) => ({ ...prev, showHintInfoMb: !prev.showHintInfoMb }))}>
                {!showHintInfoMb ? (
                    <Image src="images/infoWhite.svg" styles={{ height: "24px", width: "24px" }} />
                ) : (
                    <Image src="images/infoWhiteFull.svg" styles={{ height: "24px", width: "24px" }} />
                )}
            </button>
        );
    };

    renderHeader = () => {
        const { echeqAction, isDesktop, embeddedInV3Shell } = this.props;
        const hideMobileLegacyHeader = embeddedInV3Shell && isUxDashboardImprovementsEnabled() && !isDesktop;
        const title = echeqAction.echeqList?.length > 1 ? "echeqs.negotiate.title.multi" : "echeqs.negotiate.title";

        if (isDesktop) {
            return (
                <>
                    <Head onBack={this.handleBack} headerClassName="negotiate-header" />

                    <Head
                        title={title}
                        headerClassName="mb-md-3"
                        titleClassName="align-font-fix-04"
                        handleClickMessage="global.download"
                        centerContentClassName="p-0"
                        hasInlineButtons>
                        <Hint
                            idMessage={`${FORM_ID}.${echeqAction?.action?.toLowerCase()}.information`}
                            styleText={{
                                maxWidth: "35rem",
                            }}
                            styleDiv={{ marginLeft: "0.5rem" }}
                            styleImage={{ alignSelf: "center", margin: !isDesktop && "2rem 0 1.5rem" }}
                            classNameHintP="hint-font-size-small font-weight-normal my-0"
                            alwaysShowMessage
                        />
                    </Head>
                </>
            );
        }

        if (hideMobileLegacyHeader) {
            return null;
        }

        return (
            <Head
                headerClassName="blue-main-header-mobile"
                titleClassName="w-100"
                onBack={this.handleBack}
                title={title}
                rightContent={this.rightContentMobile}
            />
        );
    };

    render() {
        const { echeqAction, accounts, isDesktop, embeddedInV3Shell } = this.props;
        const { showHintInfoMb } = this.state;
        const formattedMessage = () => {
            const msg = i18n.get(`${FORM_ID}.${echeqAction?.action?.toLowerCase()}.information`);
            const arr = [-4];

            for (let i = 0; i < msg.length; i++) {
                const element = msg[i];
                if (element === "<") {
                    arr.push(i);
                }
            }
            const arrTxt = [];
            for (let i = 0; i < arr.length; i++) {
                if (i === arr.length - 1) {
                    arrTxt.push(msg.slice(arr[i] + 4));
                } else {
                    arrTxt.push(msg.slice(arr[i] + 4, arr[i + 1]));
                }
            }

            return arrTxt.join("");
        };
        const echeqCurrency = echeqAction?.echeqList?.[0]?.moneda;
        const accountList = accounts.filter((account) => account.currency === (currencyMap[echeqCurrency] || "0"));

        return (
            <>
                <div className="admin-detail-head px-0">
                    {this.renderHeader()}
                    {!isDesktop && showHintInfoMb && (
                        <span className="hint-snackbar-mobile px-4 py-2">{formattedMessage()}</span>
                    )}
                </div>
                {!embeddedInV3Shell && <Notification scopeToShow="echeqs" />}
                <MainContainer>
                    <div className="above-the-fold">
                        <Form>
                            <Container className="flex-grow align-items-center" gridClassName="form-content">
                                <Col
                                    xs={12}
                                    className={classNames("container-white py-3 mb-2", { "mt-4": !isDesktop })}>
                                    <Container className="flex-grow align-items-center" gridClassName="form-content">
                                        <Col xs={12} md={8} lg={6} className="px-2">
                                            <Row className="mx-0">
                                                <I18n
                                                    upperCase
                                                    component="span"
                                                    id="echeqs.add.beneficiary"
                                                    componentProps={{
                                                        style: {
                                                            margin: "0 10px 0.7em 0",
                                                            fontFamily: "Graphik-Regular",
                                                        },
                                                    }}
                                                />
                                                <I18n
                                                    upperCase
                                                    id="global.bankName"
                                                    componentProps={{ className: "data-desc" }}
                                                />
                                            </Row>
                                            <Row className="mx-0">
                                                <I18n
                                                    upperCase
                                                    component="span"
                                                    id="echeqs.type.label"
                                                    componentProps={{
                                                        style: { margin: "0 10px 0 0", fontFamily: "Graphik-Regular" },
                                                    }}
                                                />
                                                <I18n
                                                    id="echeqs.nom.label"
                                                    componentProps={{ className: "data-desc" }}
                                                />
                                            </Row>
                                        </Col>
                                    </Container>
                                </Col>
                                <Col xs={12} className="container-white py-3 px-0">
                                    <Container className="flex-grow align-items-center" gridClassName="form-content">
                                        <Col xs={12} md={8} lg={6} className="px-0 negotiate-field">
                                            <Col xs={12} md={6}>
                                                <Field
                                                    name="account"
                                                    component={Productselector}
                                                    idField="account"
                                                    data={{
                                                        emptyOptionLabel: "",
                                                        options: accountList,
                                                    }}
                                                    disabled={accountList.length === 0}
                                                    isRequired
                                                    mode="edit"
                                                    labelText="transfers.creditaccount.label"
                                                    idForm={FORM_ID}
                                                    isDesktop={isDesktop}
                                                    customPlaceholder={i18n.get(
                                                        "transfers.productSelector.placeholder",
                                                    )}
                                                    notBold
                                                    small
                                                />
                                            </Col>
                                        </Col>
                                    </Container>
                                    <Container className="flex-grow align-items-center" gridClassName="form-content">
                                        <Col xs={12} md={8} lg={6} className="px-0 negotiate-field">
                                            <Col xs={12} md={6}>
                                                <Field
                                                    component={TextField}
                                                    hidePlaceholder
                                                    idForm={FORM_ID}
                                                    name="reference"
                                                    type="text"
                                                    style={{ paddingTop: "13px", paddingBottom: "13px" }}
                                                />
                                            </Col>
                                            <Col xs={12} md={6}>
                                                <Field
                                                    component={TextField}
                                                    hidePlaceholder
                                                    idForm={FORM_ID}
                                                    name="referencevalue"
                                                    type="text"
                                                    style={{ paddingTop: "13px", paddingBottom: "13px" }}
                                                />
                                            </Col>
                                        </Col>
                                    </Container>
                                </Col>
                            </Container>
                            <Container className="flex-grow align-items-center" gridClassName="form-content">
                                <Col
                                    xs={12}
                                    md={8}
                                    lg={4}
                                    className={classNames({ "mt-1": !isDesktop, "mt-5": isDesktop })}>
                                    <Container className="flex-grow align-items-center" gridClassName="form-content">
                                        <Button
                                            type="submit"
                                            bsStyle="primary"
                                            label="global.continue"
                                            style={{ marginTop: "2rem" }}
                                        />
                                    </Container>
                                </Col>
                            </Container>
                        </Form>
                    </div>
                </MainContainer>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    option: selectors.getEcheqOption(state),
    echeqAction: selectors.getEcheqsToDoActions(state),
    accounts: accountsSelectors.getAccounts(state),
    loggedUser: sessionSelectors.getUser(state),
});

export default compose(
    connect(mapStateToProps),
    withFormik({
        mapPropsToValues: () => ({ account: "", reference: "", referencevalue: "" }),
        validationSchema: () =>
            Yup.object().shape({
                account: Yup.string().required(i18n.get(`${FORM_ID}.error.required`)),
            }),
        handleSubmit: (form, formikBag) => {
            const { dispatch, accounts } = formikBag.props;
            const { setSubmitting } = formikBag;
            const completeAccount = accounts.find(({ idProduct }) => idProduct === form.account);
            if (!completeAccount) {
                setSubmitting(false);
                return;
            }
            const { productType, productAlias, number: accountNumber, currency } = completeAccount;
            const currencyDescription = i18n.get(`currency.label.${currency}`);
            const account = productAlias || maskedAccountNumber(accountNumber);
            const accountLabel = `${account} ${productType} ${currencyDescription}`;
            const negotiateForm = { ...form, type: "NOM", cbu: completeAccount?.cbu, accountLabel };
            dispatch(actions.endorseEcheqData(negotiateForm));
            dispatch(push("/echeqs/action/endorse/confirm"));
        },
    }),
)(NegotiateEcheq);
